import React, { useMemo, forwardRef } from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';

import { DATE_WITH_HOUR } from 'utils/dateFormat';
import { ReactComponent as ExclamationMarker } from 'assets/icons/exclamation-circle-solid.svg';

const ListItem = forwardRef(({ activeItemId, event, idx, onClick }, ref) => {
  const onClickItem = (item) => {
    if (activeItemId === item.id) return;
    onClick(item.id);
  };

  const customLabels = useMemo(() => {
    return {
      'refund.processed': 'Refunded',
      'dispute.funds_withdrawn': 'Disputed'
    }
  }, []);

  const [eventType, eventStatus] = event.event.split('.');
  const isDisputed = eventType === 'dispute';

  const eventData = useMemo(() => {
    return (
      <>
        <p className="text-javelin-gray-dark text-xs font-bold capitalize">
          {customLabels[eventType] || `${eventType} ${eventStatus}`}
        </p>
        <p className="text-javelin-gray-dark text-xs capitalize">
          {eventType} ID: <span className='underline' >{event.id}</span>
        </p>
        {isDisputed && (
          <p className="text-javelin-gray-dark text-xs">
            <span className='underline' >Submit Evidence</span> by 12/09/2021
          </p>
        )}
      </>
    )
  }, [customLabels, event.id, eventStatus, eventType, isDisputed]);

  return (
    <li className={`relative ${isDisputed ? 'list-none' : ''}`} ref={ref}>
      {idx !== 'last' && (
        <div className="bg-black bg-opacity-10 h-4/6 w-px absolute top-10 bottom-12 -left-4 ml-px" />
      )}
      {isDisputed && (
        <ExclamationMarker style={{ fill: '#ac863f' }} className='absolute w-3 h-3 top-4 -left-5' />
      )}
      <div
        className={`border p-3.5 mb-2 rounded box-border cursor-pointer grid grid-flow-row gap-1.5 ${activeItemId === event.id
          ? `${isDisputed ? 'border-amber' : 'border-brand-primary'}`
          : 'border-javelin-inputBorder'
          }`}
        onClick={() => onClickItem(event)}
        data-testid={event.id}
      >
        {eventData}
        <p className="text-javelin-gray-light text-xs mt-1.5">
          {format(
            new Date(event.created_at),
            DATE_WITH_HOUR
          )}
        </p>
      </div>
    </li>
  );
});

ListItem.propTypes = {
  event: PropTypes.shape({}),
  activeItem: PropTypes.shape({}),
  idx: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
};

export default ListItem;
